export default function EFArrowRight(props: any) {
    return (
        <svg
            width="14px"
            height="8px"
            viewBox="0 0 22 13"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="M端-CSR社会貢献" transform="translate(-221.000000, -5188.000000)" stroke="#000000">
                    <g id="编组-6" transform="translate(30.000000, 3899.000000)">
                        <g id="编组-17" transform="translate(103.000000, 1285.000000)">
                            <g id="编组-10" transform="translate(88.000000, 5.000000)">
                                <polyline
                                    id="路径"
                                    transform="translate(15.168921, 5.500000) rotate(45.000000) translate(-15.168921, -5.500000) "
                                    points="11.2798339 1.6109127 19.0580085 1.6109127 19.0580085 9.3890873"
                                ></polyline>
                                <line x1="0" y1="5.60050506" x2="20" y2="5.60050506" id="路径-11"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
